import { Component, Fragment } from 'react';
import { IBaseComponentProps, NSBoxRadio, NSSpace, NSSpaceSizeType, NSTitle } from 'namirasoft-site-react';
import { NSARouterMakerResult } from 'namirasoft-account-react';
import { PaymentProps } from '../PaymentProps';
import Styles from './NSPPaymentMethod.module.css';
import { GatewayType } from 'namirasoft-payment';

export interface NSPPaymentMethodProps extends IBaseComponentProps, PaymentProps, NSARouterMakerResult
{
	onClickedRadio: (title: string) => void;
}

interface NSPPaymentMethodState
{
	selected: string;
}

let gateways = [
	{ id: "1", name: "Stripe", logo: "https://static.namirasoft.com/image/concept/card/stripe.png" },
	// { id: "2", name: "Paypal", logo: "https://static.namirasoft.com/image/concept/card/paypal.png" },
]

class NSPPaymentMethod extends Component<NSPPaymentMethodProps, NSPPaymentMethodState>
{
	constructor(props: NSPPaymentMethodProps)
	{
		super(props);
		this.state = { selected: gateways[0].name };
	}
	getValue(): GatewayType
	{
		return this.state.selected as GatewayType;
	}
	override render()
	{
		return (
			<>
				<NSSpace size={NSSpaceSizeType.SMALL} />
				<NSTitle title='Please choose a payment method:' classList={[Styles.nsp_payment_method_title]} />
				<NSSpace size={NSSpaceSizeType.SMALL} />
				{
					gateways.map((gateway, index) => (
						<Fragment key={index}>
							<div className={Styles.nsp_method}>
								<img
									src={gateway.logo}
									alt={gateway.name}
									width={40}
									height={24}
								/>
								<NSBoxRadio
									id={gateway.id}
									name="getway_method"
									required={false}
									hideHeader
									title={gateway.name}
									onClicked={() => this.props.onClickedRadio(gateway.name)}
									checked={gateway.name === this.state.selected}
									onChanged={(e) =>
									{
										if (e.getValue())
											this.setState({ selected: gateway.name });
									}}
								/>
							</div>
							<NSSpace size={NSSpaceSizeType.SMALL} />
						</Fragment>
					))
				}
			</>
		);
	}
}

export default NSPPaymentMethod;